// Satış tutarı / ödeme yöntemi gösterim yardımcıları. Satışlar ekranı (RetailSales) ve Gün Sonu
// raporunun Genel sekmesi (EndOfDayGenel — iOS WebView sayfası dahil) aynı fonksiyonları kullanır.
import { stripBankAccountType, isShopifySale, shopifyPaymentLabel } from './kasaOzeti';

// Ürün bazlı indirim toplamını hesapla
export const getItemsDiscountSum = (sale) => {
  if (!sale.items || sale.items.length === 0) return 0;
  return sale.items.reduce((sum, item) => {
    const qty = Math.abs(Number(item.quantity) || 1);
    const perUnit = Number(item.discount_amount || 0);
    return sum + (perUnit * qty);
  }, 0);
};

// Satış listesinde gösterilecek toplam tutar (hurda dahil)
export const getSaleDisplayAmount = (sale) => {
  const total = Number(sale.total) || 0;
  const subtotal = Number(sale.subtotal) || 0;
  const discount = Number(sale.discount) || 0;
  const scrapAmount = Number(sale.scrap_total_amount) || 0;
  const scrapDebt = Number(sale.scrap_debt_discount) || 0;
  const adjTotal = Number(sale.adjustment_total) || 0;
  // Nakit İade: hurda tutarı ürün değerini aştığında, sadece ürün net değerini göster
  if (sale.payment_method === 'Nakit İade' && scrapAmount > 0 && total === 0) {
    const netProductValue = subtotal - discount;
    return netProductValue > 0 ? netProductValue : scrapAmount;
  }
  // total == subtotal ve indirim varsa, indirim total'e uygulanmamış olabilir
  if (discount > 0 && subtotal > 0 && Math.abs(total - subtotal) < 1) {
    // İndirim ürün fiyatlarına dağıtılmış mı kontrol et (discount_amount toplamı sepet indirimine yakınsa)
    const itemsDiscSum = getItemsDiscountSum(sale);
    if (itemsDiscSum > 0 && Math.abs(itemsDiscSum - discount) < 1) {
      return total + scrapAmount;
    }
    return total - discount - scrapDebt;
  }
  // adjustment_total varsa ama total'e dahil edilmemişse ekle (eski exchange satışları)
  if (adjTotal > 0 && subtotal > 0 && Math.abs(total - (subtotal - discount)) < 1) {
    return total + adjTotal + scrapAmount;
  }
  return total + scrapAmount;
};

// Ödeme yöntemini banka hesap bilgisi ile formatla
export const formatPaymentMethod = (sale) => {
  if (!sale) return '-';
  const method = sale.payment_method || '-';

  // Shopify siparişi (payment_method "shopify_iyzico - Kredi ve Banka Kartları") → "E-Ticaret (Shopify iyzico)"
  if (isShopifySale(sale)) return `E-Ticaret (${shopifyPaymentLabel(method)})`;

  // Havale/EFT veya Karışık ise payment_details'dan banka hesap bilgisini al
  if ((method === 'Havale/EFT' || method === 'Karışık') && sale.payment_details) {
    try {
      const details = typeof sale.payment_details === 'string'
        ? JSON.parse(sale.payment_details)
        : sale.payment_details;

      if (Array.isArray(details)) {
        const havalePayment = details.find(d => d.method === 'Havale/EFT' && d.bank_account);
        if (havalePayment && havalePayment.bank_account) {
          const accountName = stripBankAccountType(havalePayment.bank_account);
          if (method === 'Karışık') {
            return `Karışık (${accountName})`;
          }
          return `Havale/EFT (${accountName})`;
        }
      }
    } catch (e) {
      // JSON parse hatası - normal method döndür
    }
  }
  return method;
};
